import { useState, useCallback } from "react";
import { useToast } from "../admin/components/Toast";
import {
  getMe as apiGetMe,
  getMyPosts as apiGetMyPosts,
  updateMe as apiUpdateMe,
  RequestPasswordReset as apiRequestPasswordReset,
  ResetPassword as apiResetPassword,
} from "../api/user";

const useUser = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const { addToast } = useToast();

  const getMe = async (token) => {
    if (token == null || token == "") {
      return;
    }
    setLoading(true);
    try {
      const data = await apiGetMe(token);
      setUser(data);
      return data;
    } catch (err) {
      // addToast(
      //   err?.response?.data?.detail || "Failed to fetch user info",
      //   "error"
      // );
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getMyPosts = async (token) => {
    setLoading(true);
    try {
      const data = await apiGetMyPosts(token);
      return data;
    } catch (err) {
      addToast(
        err?.response?.data?.detail || "Failed to fetch your posts",
        "error"
      );
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateMe = async (token, payload) => {
    setLoading(true);
    try {
      const data = await apiUpdateMe(token, payload);
      addToast("Account updated successfully.", "success");
      return data;
    } catch (err) {
      addToast(
        err?.response?.data?.detail || "Failed to update account.",
        "error"
      );
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const RequestPasswordReset = async(email) =>{
    setLoading(true)
    try {
      const data = await apiRequestPasswordReset(email);
      return data;
    } catch (err) {
      addToast(
        err?.response?.data?.detail || "Failed to request password reset",
        "error"
      );
      throw err;
    } finally {
      setLoading(false);
    }
  }

  const ResetPassword = async(email,new_password) =>{
    try {
      const data = await apiResetPassword(email,new_password);
      return data;
    } catch (error) {
      addToast(
        error?.response?.data?.detail || "Failed to reset password",
        "error"
      );
      throw error;
    }
  }
  return { user, getMe, getMyPosts, updateMe, loading, RequestPasswordReset, ResetPassword };
};

export default useUser;
